/**
 * True for real files under `services/` — excludes folder placeholder
 * entries (e.g. the bare `services/`) that the backend may include in
 * `draft.files`.
 */
export const isServiceScriptFile = (path: string): boolean =>
  path.startsWith('services/') && !path.endsWith('/');
